import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

// WCAG 2.2 SC 2.4.2 (Page Titled). Every admin, employee and portal screen
// used to inherit the marketing site's title, so 44 distinct pages were all
// "Dog Boarding & Daycare | Ocean Beach, San Diego | The Dog Lodge" — useless
// in a tab strip and meaningless to a screen-reader user landing on a page.
//
// One table instead of a Helmet in every component. A page that renders its
// own <Helmet><title> still wins: react-helmet-async applies the deepest one.
const TITLES = [
  [/^\/secure\/?$/, 'Dashboard'],
  [/^\/secure\/check-ins/, 'Check Ins'],
  [/^\/secure\/clients\/\d+\/vaccinations/, 'Client Vaccinations'],
  [/^\/secure\/clients\/\d+\/bookings\/\d+\/edit/, 'Edit Booking'],
  [/^\/secure\/clients\/\d+\/create-booking/, 'New Booking'],
  [/^\/secure\/clients\/\d+/, 'Client Profile'],
  [/^\/secure\/clients/, 'Clients'],
  [/^\/secure\/animals/, 'Pets'],
  [/^\/secure\/booking-requests/, 'Booking Requests'],
  [/^\/secure\/bookings\/\d+/, 'Booking Detail'],
  [/^\/secure\/bookings/, 'Bookings'],
  [/^\/secure\/vaccination-requirements/, 'Vaccine Requirements'],
  [/^\/secure\/vaccination-reviews/, 'Vaccination Reviews'],
  [/^\/secure\/vaccinations/, 'Vaccinations'],
  [/^\/secure\/blocked-dates/, 'Blocked Dates'],
  [/^\/secure\/suppressions/, 'Email Suppression List'],
  [/^\/secure\/employees\/\d+/, 'Employee Profile'],
  [/^\/secure\/employees/, 'Employees'],
  [/^\/secure\/dog-photos/, 'Dog Photos'],
  [/^\/secure\/leads\/\d+/, 'Lead Detail'],
  [/^\/secure\/leads/, 'Leads'],
  [/^\/secure\/outreach\/compose/, 'Compose Outreach'],
  [/^\/secure\/outreach/, 'Outreach'],
  [/^\/secure\/change-log/, 'Change Log'],
  [/^\/secure\/updates/, 'Updates'],
  [/^\/secure\/today/, "Today's Bookings"],
  [/^\/secure\/revenue/, 'Revenue'],
  [/^\/secure\/projections/, 'Projections'],
  [/^\/secure\/admin\/blog/, 'Blog Queue'],
  [/^\/secure\/staff-messages/, 'Staff Messages'],
  [/^\/secure\/setup-shortcut/, 'Shortcut Setup'],
  [/^\/secure\/media-library/, 'Media Library'],
  [/^\/secure\/instagram-upload/, 'Instagram Upload'],
  [/^\/secure\/post-queue/, 'Instagram Queue'],
  [/^\/employee\/dog\/\d+\/report-card/, 'Report Card'],
  [/^\/employee\/dog\/\d+/, 'Dog Profile'],
  [/^\/employee\/dogs/, 'Dogs'],
  [/^\/employee\/schedule/, 'Schedule'],
  [/^\/employee\/me/, 'My Profile'],
  [/^\/employee\/?$/, 'Staff Home'],
  [/^\/portal\/bookings\/\d+\/edit/, 'Edit Booking'],
  [/^\/portal\/bookings\/\d+/, 'Booking Details'],
  [/^\/portal\/pets\/\d+\/vaccinations/, 'Vaccination Records'],
  [/^\/portal\/packages\/\d+/, 'Package'],
  [/^\/portal\/book/, 'Book a Stay'],
  [/^\/portal\/settings/, 'Account Settings'],
  [/^\/portal\/onboarding/, 'Welcome'],
  [/^\/portal\/?$/, 'My Dashboard'],
];

const AREA = [
  [/^\/secure/, 'Admin'],
  [/^\/employee/, 'Staff'],
  [/^\/portal/, 'Client Portal'],
];

const RouteTitle = () => {
  const { pathname } = useLocation();
  const area = AREA.find(([rx]) => rx.test(pathname));
  if (!area) return null; // public pages set their own titles
  const hit = TITLES.find(([rx]) => rx.test(pathname));
  if (!hit) return null;
  return (
    <Helmet>
      <title>{`${hit[1]} | ${area[1]} | The Dog Lodge`}</title>
    </Helmet>
  );
};

export default RouteTitle;
